export default __webpack_public_path__ + "static/software-85c13bfff349566d4b35af2efabab7ba.jpg";